var map = {
	"./app-icons/abstract/attach-solid.svg": 19441,
	"./app-icons/abstract/attach.svg": 37395,
	"./app-icons/abstract/design-solid.svg": 78644,
	"./app-icons/abstract/design.svg": 92838,
	"./app-icons/abstract/emoji-solid.svg": 44796,
	"./app-icons/abstract/emoji.svg": 43534,
	"./app-icons/abstract/extensions-solid.svg": 60664,
	"./app-icons/abstract/extensions.svg": 7994,
	"./app-icons/abstract/look-and-feel-solid.svg": 37344,
	"./app-icons/abstract/look-and-feel.svg": 76578,
	"./app-icons/abstract/pin-solid.svg": 82887,
	"./app-icons/abstract/pin.svg": 77345,
	"./app-icons/abstract/send-solid.svg": 75540,
	"./app-icons/abstract/send.svg": 22886,
	"./app-icons/abstract/social-likes-solid.svg": 95548,
	"./app-icons/abstract/social-likes.svg": 7694,
	"./app-icons/abstract/vacation-solid.svg": 76263,
	"./app-icons/abstract/vacation.svg": 98817,
	"./app-icons/business/agreement-solid.svg": 38774,
	"./app-icons/business/agreement.svg": 61112,
	"./app-icons/business/coins-solid.svg": 53944,
	"./app-icons/business/coins.svg": 3802,
	"./app-icons/business/dollar-solid.svg": 99732,
	"./app-icons/business/dollar.svg": 36934,
	"./app-icons/business/donut-solid.svg": 99734,
	"./app-icons/business/donut.svg": 57464,
	"./app-icons/business/stats-solid.svg": 859,
	"./app-icons/business/stats.svg": 55957,
	"./app-icons/comms/ads1-solid.svg": 64436,
	"./app-icons/comms/ads1.svg": 46278,
	"./app-icons/comms/ads2-solid.svg": 48459,
	"./app-icons/comms/ads2.svg": 78053,
	"./app-icons/comms/calls-solid.svg": 55438,
	"./app-icons/comms/calls.svg": 5808,
	"./app-icons/comms/email-solid.svg": 22921,
	"./app-icons/comms/email.svg": 46347,
	"./app-icons/crisis/bug-solid.svg": 65013,
	"./app-icons/crisis/bug.svg": 49463,
	"./app-icons/crisis/fire-solid.svg": 31129,
	"./app-icons/crisis/fire.svg": 667,
	"./app-icons/crisis/flood-solid.svg": 87735,
	"./app-icons/crisis/flood.svg": 8561,
	"./app-icons/crisis/hazard-solid.svg": 24989,
	"./app-icons/crisis/hazard.svg": 34495,
	"./app-icons/crisis/medical-solid.svg": 16210,
	"./app-icons/crisis/medical.svg": 62676,
	"./app-icons/crisis/radioactive-solid.svg": 58184,
	"./app-icons/crisis/radioactive.svg": 88906,
	"./app-icons/crisis/unknown-solid.svg": 10697,
	"./app-icons/crisis/unknown.svg": 35115,
	"./app-icons/crisis/virus-solid.svg": 25968,
	"./app-icons/crisis/virus.svg": 66034,
	"./app-icons/crisis/weather-solid.svg": 56591,
	"./app-icons/crisis/weather.svg": 86121,
	"./app-icons/digital/cloud-solid.svg": 22445,
	"./app-icons/digital/cloud.svg": 22767,
	"./app-icons/digital/download-solid.svg": 22050,
	"./app-icons/digital/download.svg": 97156,
	"./app-icons/digital/image-solid.svg": 80177,
	"./app-icons/digital/image.svg": 64947,
	"./app-icons/digital/link-solid.svg": 73674,
	"./app-icons/digital/link.svg": 2124,
	"./app-icons/digital/share-ios-style-solid.svg": 90823,
	"./app-icons/digital/share-ios-style.svg": 53153,
	"./app-icons/digital/share-social-style-solid.svg": 35605,
	"./app-icons/digital/share-social-style.svg": 41687,
	"./app-icons/digital/share-solid.svg": 92875,
	"./app-icons/digital/share.svg": 38917,
	"./app-icons/digital/social-mentions-solid.svg": 94857,
	"./app-icons/digital/social-mentions.svg": 67275,
	"./app-icons/digital/thread-solid.svg": 37666,
	"./app-icons/digital/thread.svg": 17796,
	"./app-icons/digital/upload-solid.svg": 25813,
	"./app-icons/digital/upload.svg": 43351,
	"./app-icons/digital/www-solid.svg": 53235,
	"./app-icons/digital/www.svg": 8589,
	"./app-icons/general/application-solid.svg": 28860,
	"./app-icons/general/application.svg": 65102,
	"./app-icons/general/applications-solid.svg": 59479,
	"./app-icons/general/applications.svg": 32977,
	"./app-icons/general/edit-wysiwyg-solid.svg": 71742,
	"./app-icons/general/edit-wysiwyg.svg": 50432,
	"./app-icons/general/menus-solid.svg": 36750,
	"./app-icons/general/menus.svg": 46576,
	"./app-icons/general/panels-solid.svg": 35551,
	"./app-icons/general/panels.svg": 5145,
	"./app-icons/general/wiki-descriptor-solid.svg": 77088,
	"./app-icons/general/wiki-descriptor.svg": 72258,
	"./app-icons/general/wiki-rights-solid.svg": 76094,
	"./app-icons/general/wiki-rights.svg": 55872,
	"./app-icons/general/wiki-solid.svg": 63166,
	"./app-icons/general/wiki-templates-solid.svg": 81436,
	"./app-icons/general/wiki-templates.svg": 15630,
	"./app-icons/general/wiki.svg": 26400,
	"./app-icons/people/members-add-solid.svg": 40262,
	"./app-icons/people/members-add.svg": 35112,
	"./app-icons/people/users-authentication-solid.svg": 3582,
	"./app-icons/people/users-authentication.svg": 57344,
	"./app-icons/people/users-default-solid.svg": 56393,
	"./app-icons/people/users-default.svg": 28235,
	"./app-icons/people/users-groups-solid.svg": 2162,
	"./app-icons/people/users-groups.svg": 1396,
	"./app-icons/people/users-profile-solid.svg": 88865,
	"./app-icons/people/users-profile.svg": 96963,
	"./app-icons/people/users-registration-solid.svg": 78581,
	"./app-icons/people/users-registration.svg": 12567,
	"./app-icons/people/users-rights-solid.svg": 4771,
	"./app-icons/people/users-rights.svg": 76797,
	"./app-icons/security/open-solid.svg": 28826,
	"./app-icons/security/open.svg": 63260,
	"./app-icons/security/other-captcha-solid.svg": 47521,
	"./app-icons/security/other-captcha.svg": 30531,
	"./app-icons/security/private-solid.svg": 57451,
	"./app-icons/security/private.svg": 95749,
	"./app-icons/security/users-authentication-solid.svg": 16723,
	"./app-icons/security/users-authentication.svg": 88781,
	"./compact/add-field-compact-focus.svg": 52931,
	"./compact/add-field-compact.svg": 432,
	"./compact/add-record-compact-focus.svg": 88300,
	"./compact/add-record-compact.svg": 25147,
	"./compact/application-compact-focus.svg": 83987,
	"./compact/application-compact.svg": 92704,
	"./compact/approval-compact-focus.svg": 16836,
	"./compact/approval-compact.svg": 8979,
	"./compact/apps-compact-focus.svg": 82105,
	"./compact/apps-compact.svg": 87054,
	"./compact/attach-compact-focus.svg": 56222,
	"./compact/attach-compact.svg": 44277,
	"./compact/book-compact-focus.svg": 71962,
	"./compact/book-compact.svg": 30081,
	"./compact/burger-menu-compact-focus.svg": 64068,
	"./compact/burger-menu-compact.svg": 15923,
	"./compact/calendar-compact-focus.svg": 80679,
	"./compact/calendar-compact.svg": 25988,
	"./compact/camera-switch-compact-focus.svg": 51,
	"./compact/camera-switch-compact.svg": 86144,
	"./compact/card-compact-focus.svg": 10411,
	"./compact/card-compact.svg": 43800,
	"./compact/chat-compact-focus.svg": 78799,
	"./compact/chat-compact.svg": 6060,
	"./compact/close-compact-focus.svg": 55358,
	"./compact/close-compact.svg": 47110,
	"./compact/comment-compact-focus.svg": 37698,
	"./compact/comment-compact.svg": 70281,
	"./compact/copy-compact-focus.svg": 37330,
	"./compact/copy-compact.svg": 29593,
	"./compact/delete-compact-focus.svg": 24352,
	"./compact/delete-compact.svg": 31951,
	"./compact/download-compact-focus.svg": 20149,
	"./compact/download-compact.svg": 88698,
	"./compact/edit-compact-focus.svg": 12225,
	"./compact/edit-compact.svg": 14102,
	"./compact/email-compact-focus.svg": 50433,
	"./compact/email-compact.svg": 68822,
	"./compact/emoji-compact-focus.svg": 54175,
	"./compact/emoji-compact.svg": 68156,
	"./compact/export-compact-focus.svg": 49251,
	"./compact/export-compact.svg": 84656,
	"./compact/extensions-compact-focus.svg": 51907,
	"./compact/extensions-compact.svg": 74992,
	"./compact/eye-compact-focus.svg": 98518,
	"./compact/eye-compact.svg": 79373,
	"./compact/file-compact-focus.svg": 38823,
	"./compact/file-compact.svg": 68292,
	"./compact/files-add-compact-focus.svg": 31582,
	"./compact/files-add-compact.svg": 68021,
	"./compact/files-compact-focus.svg": 63496,
	"./compact/files-compact.svg": 16087,
	"./compact/filter-compact-focus.svg": 82191,
	"./compact/filter-compact.svg": 67852,
	"./compact/filtered-compact-focus.svg": 76240,
	"./compact/filtered-compact.svg": 25087,
	"./compact/folder-closed-add-compact-focus.svg": 78798,
	"./compact/folder-closed-add-compact.svg": 46885,
	"./compact/folder-closed-compact-focus.svg": 88856,
	"./compact/folder-closed-compact.svg": 27463,
	"./compact/folder-closed-move-up-compact-focus.svg": 85624,
	"./compact/folder-closed-move-up-compact.svg": 4903,
	"./compact/folder-empty-compact-focus.svg": 67425,
	"./compact/folder-empty-compact.svg": 82454,
	"./compact/folder-move-compact-focus.svg": 46487,
	"./compact/folder-move-compact.svg": 51252,
	"./compact/folder-open-compact-focus.svg": 89116,
	"./compact/folder-open-compact.svg": 45355,
	"./compact/folder-up-compact-focus.svg": 51267,
	"./compact/folder-up-compact.svg": 72624,
	"./compact/form-compact-focus.svg": 98103,
	"./compact/form-compact.svg": 51284,
	"./compact/gantt-compact-focus.svg": 12967,
	"./compact/gantt-compact.svg": 93060,
	"./compact/grid-compact-focus.svg": 7533,
	"./compact/grid-compact.svg": 36018,
	"./compact/group-compact-focus.svg": 73672,
	"./compact/group-compact.svg": 77111,
	"./compact/history-compact-focus.svg": 45733,
	"./compact/history-compact.svg": 30410,
	"./compact/home-compact-focus.svg": 12224,
	"./compact/home-compact.svg": 21487,
	"./compact/horizontal-ellipsis-compact-focus.svg": 38225,
	"./compact/horizontal-ellipsis-compact.svg": 55014,
	"./compact/image-compact-focus.svg": 57530,
	"./compact/image-compact.svg": 84609,
	"./compact/info-compact-focus.svg": 49133,
	"./compact/info-compact.svg": 74674,
	"./compact/kanban-compact-focus.svg": 4196,
	"./compact/kanban-compact.svg": 82931,
	"./compact/link-add-compact-focus.svg": 20647,
	"./compact/link-add-compact.svg": 3140,
	"./compact/link-compact-focus.svg": 8141,
	"./compact/link-compact.svg": 94194,
	"./compact/list-compact-focus.svg": 64689,
	"./compact/list-compact.svg": 79526,
	"./compact/lock-compact-focus.svg": 22000,
	"./compact/lock-compact.svg": 68159,
	"./compact/log-out-compact-focus.svg": 91732,
	"./compact/log-out-compact.svg": 31395,
	"./compact/look-and-feel-compact-focus.svg": 25135,
	"./compact/look-and-feel-compact.svg": 61324,
	"./compact/maximise-compact-focus.svg": 45656,
	"./compact/maximise-compact.svg": 14631,
	"./compact/meeting-participant-add-compact-focus.svg": 20052,
	"./compact/meeting-participant-add-compact.svg": 83619,
	"./compact/members-add-compact-focus.svg": 6406,
	"./compact/members-add-compact.svg": 97949,
	"./compact/members-compact-focus.svg": 39008,
	"./compact/members-compact.svg": 48367,
	"./compact/microphone-compact-focus.svg": 96409,
	"./compact/microphone-compact.svg": 60622,
	"./compact/minimise-compact-focus.svg": 32650,
	"./compact/minimise-compact.svg": 30129,
	"./compact/news-compact-focus.svg": 86768,
	"./compact/news-compact.svg": 17631,
	"./compact/note-compact-focus.svg": 19649,
	"./compact/note-compact.svg": 42134,
	"./compact/notifications-compact-focus.svg": 81465,
	"./compact/notifications-compact.svg": 25358,
	"./compact/open-compact-focus.svg": 23069,
	"./compact/open-compact.svg": 49858,
	"./compact/organiser-compact-focus.svg": 19491,
	"./compact/organiser-compact.svg": 12848,
	"./compact/other-captcha-compact-focus.svg": 83918,
	"./compact/other-captcha-compact.svg": 11717,
	"./compact/phone-compact-focus.svg": 20677,
	"./compact/phone-compact.svg": 78666,
	"./compact/pin-compact-focus.svg": 28300,
	"./compact/pin-compact.svg": 98043,
	"./compact/play-compact-focus.svg": 46207,
	"./compact/play-compact.svg": 49788,
	"./compact/plus-compact-focus.svg": 12793,
	"./compact/plus-compact.svg": 70830,
	"./compact/privacy-compact-focus.svg": 76845,
	"./compact/privacy-compact.svg": 34642,
	"./compact/profile-compact-focus.svg": 77538,
	"./compact/profile-compact.svg": 24425,
	"./compact/reaction-add-compact-focus.svg": 35518,
	"./compact/reaction-add-compact.svg": 14837,
	"./compact/refresh-compact-focus.svg": 7628,
	"./compact/refresh-compact.svg": 88379,
	"./compact/reset-compact.svg": 23927,
	"./compact/search-compact-focus.svg": 52477,
	"./compact/search-compact.svg": 41186,
	"./compact/send-compact-focus.svg": 89491,
	"./compact/send-compact.svg": 73344,
	"./compact/settings-compact-focus.svg": 6650,
	"./compact/settings-compact.svg": 68449,
	"./compact/share-compact-focus.svg": 82956,
	"./compact/share-compact.svg": 89563,
	"./compact/sliders-compact-focus.svg": 64487,
	"./compact/sliders-compact.svg": 10660,
	"./compact/social-likes-compact-focus.svg": 65127,
	"./compact/social-likes-compact.svg": 79844,
	"./compact/start-thread-compact-focus.svg": 92932,
	"./compact/start-thread-compact.svg": 68243,
	"./compact/stats-compact-focus.svg": 72263,
	"./compact/stats-compact.svg": 3075,
	"./compact/table-compact-focus.svg": 33401,
	"./compact/table-compact.svg": 88654,
	"./compact/tag-compact-focus.svg": 6413,
	"./compact/tag-compact.svg": 23474,
	"./compact/tasks-compact-focus.svg": 64183,
	"./compact/tasks-compact.svg": 35028,
	"./compact/templates-compact-focus.svg": 20360,
	"./compact/templates-compact.svg": 14967,
	"./compact/text-file-compact-focus.svg": 71885,
	"./compact/text-file-compact.svg": 87218,
	"./compact/tile-view-compact-focus.svg": 10495,
	"./compact/tile-view-compact.svg": 16540,
	"./compact/trash-3-compact.svg": 30564,
	"./compact/trash-compact-focus.svg": 9723,
	"./compact/trash-compact.svg": 64264,
	"./compact/unknown-warning-compact-focus.svg": 20660,
	"./compact/unknown-warning-compact.svg": 4963,
	"./compact/users-authentication-compact-focus.svg": 46572,
	"./compact/users-authentication-compact.svg": 47867,
	"./compact/video-compact-focus.svg": 52956,
	"./compact/video-compact.svg": 3819,
	"./compact/visibility-hidden.svg": 39443,
	"./compact/visibility-invisible.svg": 5136,
	"./compact/visibility-visible.svg": 77115,
	"./compact/workflows-compact-focus.svg": 83859,
	"./compact/workflows-compact.svg": 70400,
	"./compact/workspaces-compact-focus.svg": 98323,
	"./compact/workspaces-compact.svg": 65088,
	"./compact/x-compact-focus.svg": 62689,
	"./compact/x-compact.svg": 47734,
	"./compact/zoom-in-compact-focus.svg": 342,
	"./compact/zoom-in-compact.svg": 7949,
	"./compact/zoom-out-compact-focus.svg": 70899,
	"./compact/zoom-out-compact.svg": 91872,
	"./compact/zoom-reset-compact-focus.svg": 4766,
	"./compact/zoom-reset-compact.svg": 92309,
	"./emoji-category/activity.svg": 12797,
	"./emoji-category/foods.svg": 15681,
	"./emoji-category/nature.svg": 64119,
	"./emoji-category/objects.svg": 20490,
	"./emoji-category/peoples.svg": 88450,
	"./emoji-category/places.svg": 86790,
	"./emoji-category/symbols.svg": 35073,
	"./flat/add-compact.svg": 85921,
	"./flat/add-field-compact.svg": 2050,
	"./flat/add-field-light.svg": 23037,
	"./flat/add-field-solid.svg": 3764,
	"./flat/add-fork-compact.svg": 35346,
	"./flat/add-fork-light.svg": 1773,
	"./flat/add-fork-solid.svg": 94948,
	"./flat/add-light.svg": 31134,
	"./flat/add-record-compact.svg": 86437,
	"./flat/add-record-light.svg": 36306,
	"./flat/add-record-solid.svg": 8751,
	"./flat/add-solid.svg": 98075,
	"./flat/ai-compact.svg": 14466,
	"./flat/ai-light.svg": 61949,
	"./flat/ai-solid.svg": 55636,
	"./flat/application-compact.svg": 68426,
	"./flat/application-index-compact.svg": 61741,
	"./flat/application-index-light.svg": 40458,
	"./flat/application-index-solid.svg": 78119,
	"./flat/application-light.svg": 31061,
	"./flat/application-solid.svg": 75212,
	"./flat/approval-compact.svg": 35217,
	"./flat/approval-light.svg": 56014,
	"./flat/approval-solid.svg": 92459,
	"./flat/apps-compact.svg": 49956,
	"./flat/apps-light.svg": 39887,
	"./flat/apps-solid.svg": 47074,
	"./flat/attach-compact.svg": 77507,
	"./flat/attach-light.svg": 94168,
	"./flat/attach-solid.svg": 27305,
	"./flat/attribute-type/article.svg": 18930,
	"./flat/attribute-type/checkbox.svg": 51607,
	"./flat/attribute-type/content.svg": 77987,
	"./flat/attribute-type/createdBy.svg": 73259,
	"./flat/attribute-type/createdDate.svg": 76064,
	"./flat/attribute-type/date.svg": 93848,
	"./flat/attribute-type/formula.svg": 96290,
	"./flat/attribute-type/image.svg": 8595,
	"./flat/attribute-type/lastUpdated.svg": 35561,
	"./flat/attribute-type/lastUpdatedBy.svg": 6770,
	"./flat/attribute-type/longText.svg": 74283,
	"./flat/attribute-type/number.svg": 85607,
	"./flat/attribute-type/percent.svg": 68415,
	"./flat/attribute-type/ruleset.svg": 96174,
	"./flat/attribute-type/select.svg": 69764,
	"./flat/attribute-type/task.svg": 40067,
	"./flat/attribute-type/text.svg": 82681,
	"./flat/attribute-type/time.svg": 41975,
	"./flat/attribute-type/track.svg": 36497,
	"./flat/attribute-type/url.svg": 42799,
	"./flat/attribute-type/user.svg": 38413,
	"./flat/bold.svg": 64181,
	"./flat/book-compact.svg": 98019,
	"./flat/book-light.svg": 7704,
	"./flat/book-solid.svg": 37193,
	"./flat/bottom-compact.svg": 85937,
	"./flat/bottom-light.svg": 4206,
	"./flat/bottom-solid.svg": 40651,
	"./flat/burger-menu-compact.svg": 37821,
	"./flat/burger-menu-light.svg": 10330,
	"./flat/burger-menu-solid.svg": 46679,
	"./flat/calendar-compact.svg": 3674,
	"./flat/calendar-light.svg": 81413,
	"./flat/calendar-solid.svg": 96316,
	"./flat/camera-switch-compact.svg": 22738,
	"./flat/camera-switch-light.svg": 85773,
	"./flat/camera-switch-solid.svg": 36420,
	"./flat/card-compact.svg": 53562,
	"./flat/card-light.svg": 67973,
	"./flat/card-solid.svg": 60412,
	"./flat/chat-compact.svg": 12578,
	"./flat/chat-light.svg": 92765,
	"./flat/chat-solid.svg": 58196,
	"./flat/chevron-down-compact.svg": 19134,
	"./flat/chevron-down-light.svg": 7385,
	"./flat/chevron-down-solid.svg": 12704,
	"./flat/chevron-first-compact.svg": 21484,
	"./flat/chevron-first-light.svg": 54567,
	"./flat/chevron-first-solid.svg": 74586,
	"./flat/chevron-last-compact.svg": 37178,
	"./flat/chevron-last-light.svg": 18149,
	"./flat/chevron-last-solid.svg": 10588,
	"./flat/chevron-left-compact.svg": 14885,
	"./flat/chevron-left-light.svg": 45586,
	"./flat/chevron-left-solid.svg": 99279,
	"./flat/chevron-right-compact.svg": 49492,
	"./flat/chevron-right-light.svg": 91455,
	"./flat/chevron-right-solid.svg": 11666,
	"./flat/chevron-up-compact.svg": 71549,
	"./flat/chevron-up-light.svg": 52986,
	"./flat/chevron-up-solid.svg": 89335,
	"./flat/class-compact.svg": 80260,
	"./flat/class-light.svg": 8111,
	"./flat/class-solid.svg": 66978,
	"./flat/close-compact.svg": 74832,
	"./flat/close-light.svg": 36875,
	"./flat/close-solid.svg": 98654,
	"./flat/comment-compact.svg": 56219,
	"./flat/comment-light.svg": 11040,
	"./flat/comment-solid.svg": 13073,
	"./flat/conditional-compact.svg": 89292,
	"./flat/conditional-light.svg": 98983,
	"./flat/conditional-overrides-compact.svg": 49960,
	"./flat/conditional-overrides-light.svg": 12339,
	"./flat/conditional-overrides-solid.svg": 40870,
	"./flat/conditional-solid.svg": 71578,
	"./flat/copy-compact.svg": 44531,
	"./flat/copy-light.svg": 35816,
	"./flat/copy-solid.svg": 86393,
	"./flat/dash-compact.svg": 74416,
	"./flat/dash-light.svg": 84715,
	"./flat/dash-solid.svg": 19070,
	"./flat/data-sources-compact.svg": 27073,
	"./flat/data-sources-light.svg": 82782,
	"./flat/data-sources-solid.svg": 1787,
	"./flat/delete-compact.svg": 56529,
	"./flat/delete-light.svg": 57486,
	"./flat/delete-solid.svg": 93931,
	"./flat/dismiss-compact.svg": 88936,
	"./flat/dismiss-light.svg": 44819,
	"./flat/dismiss-solid.svg": 56486,
	"./flat/do-not-disturb-compact.svg": 33429,
	"./flat/do-not-disturb-light.svg": 41954,
	"./flat/do-not-disturb-solid.svg": 14751,
	"./flat/down-2-compact.svg": 34545,
	"./flat/down-2-light.svg": 1486,
	"./flat/down-2-solid.svg": 54283,
	"./flat/down-compact.svg": 99048,
	"./flat/down-light.svg": 62387,
	"./flat/down-solid.svg": 7270,
	"./flat/download-compact.svg": 66148,
	"./flat/download-light.svg": 26831,
	"./flat/download-solid.svg": 85698,
	"./flat/draggable-handle-compact.svg": 19480,
	"./flat/draggable-handle-light.svg": 74531,
	"./flat/draggable-handle-solid.svg": 88790,
	"./flat/edit-compact.svg": 5544,
	"./flat/edit-light.svg": 38259,
	"./flat/edit-solid.svg": 33574,
	"./flat/ellipsis-horizontal-compact.svg": 73834,
	"./flat/ellipsis-horizontal-light.svg": 17333,
	"./flat/ellipsis-horizontal-solid.svg": 61484,
	"./flat/ellipsis-vertical-compact.svg": 23812,
	"./flat/ellipsis-vertical-light.svg": 93519,
	"./flat/ellipsis-vertical-solid.svg": 52386,
	"./flat/email-advanced-settings-compact.svg": 71735,
	"./flat/email-advanced-settings-light.svg": 39964,
	"./flat/email-advanced-settings-solid.svg": 17293,
	"./flat/email-compact.svg": 89492,
	"./flat/email-light.svg": 61759,
	"./flat/email-sending-compact.svg": 47501,
	"./flat/email-sending-light.svg": 55754,
	"./flat/email-sending-solid.svg": 9767,
	"./flat/email-sending-status-compact.svg": 74804,
	"./flat/email-sending-status-light.svg": 23615,
	"./flat/email-sending-status-solid.svg": 27474,
	"./flat/email-solid.svg": 65618,
	"./flat/emoji-compact.svg": 674,
	"./flat/emoji-light.svg": 33181,
	"./flat/emoji-solid.svg": 54484,
	"./flat/export-compact.svg": 3042,
	"./flat/export-light.svg": 75485,
	"./flat/export-solid.svg": 40916,
	"./flat/extensions-compact.svg": 45710,
	"./flat/extensions-light.svg": 86345,
	"./flat/extensions-solid.svg": 9008,
	"./flat/eye-compact.svg": 22331,
	"./flat/eye-light.svg": 2272,
	"./flat/eye-solid.svg": 43377,
	"./flat/favourite-star-compact.svg": 85942,
	"./flat/favourite-star-light.svg": 22113,
	"./flat/favourite-star-solid.svg": 86920,
	"./flat/file-export-compact.svg": 31805,
	"./flat/file-export-light.svg": 24858,
	"./flat/file-export-solid.svg": 61303,
	"./flat/files-add-compact.svg": 79547,
	"./flat/files-add-light.svg": 6944,
	"./flat/files-add-solid.svg": 62545,
	"./flat/files-compact.svg": 72853,
	"./flat/files-light.svg": 40226,
	"./flat/files-solid.svg": 29375,
	"./flat/filter-compact.svg": 28710,
	"./flat/filter-light.svg": 50065,
	"./flat/filter-solid.svg": 23448,
	"./flat/filtered-compact.svg": 22825,
	"./flat/filtered-light.svg": 31702,
	"./flat/filtered-solid.svg": 34291,
	"./flat/first-compact.svg": 43770,
	"./flat/first-light.svg": 57733,
	"./flat/first-solid.svg": 98012,
	"./flat/flash-compact.svg": 93126,
	"./flat/flash-light.svg": 69361,
	"./flat/flash-solid.svg": 94392,
	"./flat/folder-closed-add-compact.svg": 54323,
	"./flat/folder-closed-add-light.svg": 33640,
	"./flat/folder-closed-add-solid.svg": 89209,
	"./flat/folder-closed-compact.svg": 87229,
	"./flat/folder-closed-light.svg": 81690,
	"./flat/folder-closed-move-up-compact.svg": 37581,
	"./flat/folder-closed-move-up-light.svg": 87338,
	"./flat/folder-closed-move-up-solid.svg": 24999,
	"./flat/folder-closed-solid.svg": 18039,
	"./flat/folder-empty-compact.svg": 41324,
	"./flat/folder-empty-light.svg": 79847,
	"./flat/folder-empty-solid.svg": 99866,
	"./flat/folder-move-compact.svg": 77806,
	"./flat/folder-move-light.svg": 58761,
	"./flat/folder-move-solid.svg": 65072,
	"./flat/folder-open-compact.svg": 81549,
	"./flat/folder-open-light.svg": 32618,
	"./flat/folder-open-solid.svg": 46983,
	"./flat/folder-up-compact.svg": 73442,
	"./flat/folder-up-light.svg": 9610,
	"./flat/folder-up-solid.svg": 67956,
	"./flat/font-weight-300.svg": 29264,
	"./flat/font-weight-400.svg": 11095,
	"./flat/font-weight-500.svg": 29166,
	"./flat/font-weight-600.svg": 29269,
	"./flat/font-weight-700.svg": 74396,
	"./flat/form-compact.svg": 4882,
	"./flat/form-light.svg": 35853,
	"./flat/form-solid.svg": 2852,
	"./flat/full-screen-compact.svg": 58368,
	"./flat/full-screen-exit-compact.svg": 30177,
	"./flat/full-screen-exit-light.svg": 94270,
	"./flat/full-screen-exit-solid.svg": 96923,
	"./flat/full-screen-light.svg": 40059,
	"./flat/full-screen-solid.svg": 43054,
	"./flat/gantt-compact.svg": 55074,
	"./flat/gantt-light.svg": 72989,
	"./flat/gantt-solid.svg": 53716,
	"./flat/grid-compact.svg": 99612,
	"./flat/grid-light.svg": 34967,
	"./flat/grid-solid.svg": 37834,
	"./flat/group-2-compact.svg": 63308,
	"./flat/group-2-light.svg": 42535,
	"./flat/group-2-solid.svg": 95834,
	"./flat/group-compact.svg": 47737,
	"./flat/group-light.svg": 67078,
	"./flat/group-solid.svg": 97763,
	"./flat/help-compact.svg": 16105,
	"./flat/help-light.svg": 37878,
	"./flat/help-solid.svg": 76371,
	"./flat/history-compact.svg": 38812,
	"./flat/history-light.svg": 84407,
	"./flat/history-solid.svg": 5898,
	"./flat/home-compact.svg": 2597,
	"./flat/home-light.svg": 17554,
	"./flat/home-solid.svg": 6351,
	"./flat/image-compact.svg": 86811,
	"./flat/image-light.svg": 99744,
	"./flat/image-solid.svg": 30961,
	"./flat/index-compact.svg": 37272,
	"./flat/index-light.svg": 42083,
	"./flat/index-solid.svg": 36694,
	"./flat/info-compact.svg": 5968,
	"./flat/info-light.svg": 67467,
	"./flat/info-solid.svg": 1246,
	"./flat/italic.svg": 61468,
	"./flat/join-compact.svg": 20492,
	"./flat/join-light.svg": 10599,
	"./flat/join-solid.svg": 83194,
	"./flat/kanban-compact.svg": 81733,
	"./flat/kanban-light.svg": 93522,
	"./flat/kanban-solid.svg": 82319,
	"./flat/last-compact.svg": 35836,
	"./flat/last-light.svg": 31031,
	"./flat/last-solid.svg": 3050,
	"./flat/layout-film-strip-compact.svg": 58516,
	"./flat/layout-film-strip-light.svg": 61887,
	"./flat/layout-film-strip-solid.svg": 80850,
	"./flat/layout-full-screen-compact.svg": 66865,
	"./flat/layout-full-screen-light.svg": 1198,
	"./flat/layout-full-screen-solid.svg": 37643,
	"./flat/layout-grid-compact.svg": 73067,
	"./flat/layout-grid-light.svg": 73488,
	"./flat/layout-grid-solid.svg": 11073,
	"./flat/layout-righthand-strip-compact.svg": 36161,
	"./flat/layout-righthand-strip-light.svg": 71518,
	"./flat/layout-righthand-strip-solid.svg": 23835,
	"./flat/left-2-compact.svg": 58830,
	"./flat/left-2-light.svg": 41321,
	"./flat/left-2-solid.svg": 47632,
	"./flat/left-compact.svg": 77375,
	"./flat/left-light.svg": 89844,
	"./flat/left-solid.svg": 65189,
	"./flat/link-add-compact.svg": 50062,
	"./flat/link-add-light.svg": 53641,
	"./flat/link-add-solid.svg": 18832,
	"./flat/link-compact.svg": 40636,
	"./flat/link-light.svg": 69143,
	"./flat/link-solid.svg": 72010,
	"./flat/list-compact.svg": 17220,
	"./flat/list-light.svg": 32623,
	"./flat/list-solid.svg": 91490,
	"./flat/lock-compact.svg": 98141,
	"./flat/lock-light.svg": 76826,
	"./flat/lock-solid.svg": 18615,
	"./flat/log-out-compact.svg": 51277,
	"./flat/log-out-light.svg": 16906,
	"./flat/log-out-solid.svg": 18631,
	"./flat/look-and-feel-compact.svg": 65702,
	"./flat/look-and-feel-light.svg": 60625,
	"./flat/look-and-feel-solid.svg": 85656,
	"./flat/maximise-compact.svg": 34749,
	"./flat/maximise-light.svg": 60698,
	"./flat/maximise-solid.svg": 97143,
	"./flat/meeting-participant-add-compact.svg": 4853,
	"./flat/meeting-participant-add-light.svg": 3682,
	"./flat/meeting-participant-add-solid.svg": 92831,
	"./flat/member-out-compact.svg": 34493,
	"./flat/member-out-light.svg": 6445,
	"./flat/member-out-solid.svg": 86967,
	"./flat/members-add-compact.svg": 33391,
	"./flat/members-add-light.svg": 92964,
	"./flat/members-add-solid.svg": 83893,
	"./flat/members-compact.svg": 48705,
	"./flat/members-light.svg": 56702,
	"./flat/members-solid.svg": 5723,
	"./flat/microphone-compact.svg": 52332,
	"./flat/microphone-light.svg": 62151,
	"./flat/microphone-mute-compact.svg": 52050,
	"./flat/microphone-mute-light.svg": 96077,
	"./flat/microphone-mute-solid.svg": 63076,
	"./flat/microphone-solid.svg": 82170,
	"./flat/minimise-compact.svg": 40667,
	"./flat/minimise-light.svg": 87488,
	"./flat/minimise-solid.svg": 12241,
	"./flat/news-compact.svg": 88005,
	"./flat/news-light.svg": 78482,
	"./flat/news-solid.svg": 90703,
	"./flat/note-compact.svg": 74056,
	"./flat/note-light.svg": 80819,
	"./flat/note-solid.svg": 9350,
	"./flat/notifications-compact.svg": 44416,
	"./flat/notifications-light.svg": 98523,
	"./flat/notifications-solid.svg": 85166,
	"./flat/objects-compact.svg": 28872,
	"./flat/objects-light.svg": 16275,
	"./flat/objects-solid.svg": 67110,
	"./flat/open-compact.svg": 65228,
	"./flat/open-light.svg": 18951,
	"./flat/open-solid.svg": 88602,
	"./flat/organiser-compact.svg": 65118,
	"./flat/organiser-light.svg": 88345,
	"./flat/organiser-solid.svg": 98816,
	"./flat/other-captcha-compact.svg": 57931,
	"./flat/other-captcha-light.svg": 5552,
	"./flat/other-captcha-solid.svg": 26785,
	"./flat/phone-compact.svg": 72184,
	"./flat/phone-light.svg": 68963,
	"./flat/phone-solid.svg": 63574,
	"./flat/pin-compact.svg": 52469,
	"./flat/pin-light.svg": 31970,
	"./flat/pin-solid.svg": 21119,
	"./flat/play-2-compact.svg": 1051,
	"./flat/play-2-light.svg": 50912,
	"./flat/play-2-solid.svg": 75665,
	"./flat/play-compact.svg": 65086,
	"./flat/play-light.svg": 24537,
	"./flat/play-solid.svg": 13504,
	"./flat/plus-circle-compact.svg": 27989,
	"./flat/plus-circle-light.svg": 84770,
	"./flat/plus-circle-solid.svg": 73919,
	"./flat/plus-compact.svg": 55100,
	"./flat/plus-light.svg": 53143,
	"./flat/plus-solid.svg": 74634,
	"./flat/pop-out-to-modal-compact.svg": 40248,
	"./flat/pop-out-to-modal-light.svg": 47651,
	"./flat/pop-out-to-modal-solid.svg": 42262,
	"./flat/present-compact.svg": 37609,
	"./flat/present-light.svg": 1462,
	"./flat/present-solid.svg": 56307,
	"./flat/print-compact.svg": 47605,
	"./flat/print-light.svg": 69570,
	"./flat/print-solid.svg": 42367,
	"./flat/privacy-compact.svg": 82524,
	"./flat/privacy-light.svg": 76823,
	"./flat/privacy-solid.svg": 79690,
	"./flat/profile-compact.svg": 6667,
	"./flat/profile-light.svg": 73520,
	"./flat/profile-solid.svg": 55521,
	"./flat/reaction-add-compact.svg": 87311,
	"./flat/reaction-add-light.svg": 79012,
	"./flat/reaction-add-solid.svg": 90965,
	"./flat/refresh-compact.svg": 63265,
	"./flat/refresh-light.svg": 23454,
	"./flat/refresh-solid.svg": 59419,
	"./flat/right-2-compact.svg": 39227,
	"./flat/right-2-light.svg": 1504,
	"./flat/right-2-solid.svg": 26257,
	"./flat/right-compact.svg": 15678,
	"./flat/right-light.svg": 11590,
	"./flat/right-solid.svg": 78176,
	"./flat/rules-compact.svg": 55898,
	"./flat/rules-light.svg": 4458,
	"./flat/rules-solid.svg": 42855,
	"./flat/screenshare-compact.svg": 77197,
	"./flat/screenshare-light.svg": 51306,
	"./flat/screenshare-solid.svg": 5319,
	"./flat/search-compact.svg": 14064,
	"./flat/search-light.svg": 85707,
	"./flat/search-solid.svg": 20062,
	"./flat/send-compact.svg": 62474,
	"./flat/send-light.svg": 18197,
	"./flat/send-solid.svg": 21343,
	"./flat/settings-compact.svg": 69747,
	"./flat/settings-light.svg": 89608,
	"./flat/settings-solid.svg": 87609,
	"./flat/share-compact.svg": 81265,
	"./flat/share-light.svg": 7214,
	"./flat/share-solid.svg": 43659,
	"./flat/sheild-compact.svg": 63743,
	"./flat/sheild-light.svg": 62644,
	"./flat/sheild-solid.svg": 37989,
	"./flat/sliders-compact.svg": 60678,
	"./flat/sliders-light.svg": 47217,
	"./flat/sliders-solid.svg": 20600,
	"./flat/sliders-vertical-compact.svg": 92601,
	"./flat/sliders-vertical-light.svg": 62438,
	"./flat/sliders-vertical-solid.svg": 76643,
	"./flat/social-likes-compact.svg": 12066,
	"./flat/social-likes-light.svg": 94717,
	"./flat/social-likes-solid.svg": 60148,
	"./flat/sort-ascending-compact.svg": 98733,
	"./flat/sort-ascending-light.svg": 70442,
	"./flat/sort-ascending-solid.svg": 8103,
	"./flat/sort-compact.svg": 76296,
	"./flat/sort-descending-compact.svg": 46355,
	"./flat/sort-descending-light.svg": 79240,
	"./flat/sort-descending-solid.svg": 77241,
	"./flat/sort-light.svg": 17491,
	"./flat/sort-solid.svg": 46022,
	"./flat/start-thread-compact.svg": 2305,
	"./flat/start-thread-light.svg": 76350,
	"./flat/start-thread-solid.svg": 28667,
	"./flat/stats-compact.svg": 62609,
	"./flat/stats-light.svg": 52398,
	"./flat/stats-solid.svg": 50315,
	"./flat/strikethrough.svg": 59653,
	"./flat/table-compact.svg": 61536,
	"./flat/table-light.svg": 16571,
	"./flat/table-solid.svg": 3214,
	"./flat/tag-compact.svg": 88276,
	"./flat/tag-light.svg": 91807,
	"./flat/tag-solid.svg": 10770,
	"./flat/tasks-compact.svg": 59830,
	"./flat/tasks-light.svg": 66497,
	"./flat/tasks-solid.svg": 29416,
	"./flat/templates-compact.svg": 58297,
	"./flat/templates-light.svg": 2598,
	"./flat/templates-solid.svg": 33283,
	"./flat/text-file-compact.svg": 132,
	"./flat/text-file-light.svg": 24783,
	"./flat/text-file-solid.svg": 48322,
	"./flat/tick-2-compact.svg": 10490,
	"./flat/tick-2-light.svg": 29061,
	"./flat/tick-2-solid.svg": 21500,
	"./flat/tick-circle-compact.svg": 17416,
	"./flat/tick-circle-light.svg": 531,
	"./flat/tick-circle-solid.svg": 67718,
	"./flat/tick-compact.svg": 69891,
	"./flat/tick-light.svg": 34168,
	"./flat/tick-solid.svg": 36937,
	"./flat/tile-view-compact.svg": 9730,
	"./flat/tile-view-light.svg": 18621,
	"./flat/tile-view-solid.svg": 39924,
	"./flat/timers-compact.svg": 13890,
	"./flat/timers-light.svg": 25437,
	"./flat/timers-solid.svg": 46740,
	"./flat/top-compact.svg": 67625,
	"./flat/top-light.svg": 69590,
	"./flat/top-solid.svg": 18611,
	"./flat/trash-2-compact.svg": 41259,
	"./flat/trash-2-light.svg": 22640,
	"./flat/trash-2-solid.svg": 50689,
	"./flat/trash-3-compact.svg": 1262,
	"./flat/trash-3-light.svg": 55849,
	"./flat/trash-3-solid.svg": 62160,
	"./flat/trash-compact.svg": 46734,
	"./flat/trash-light.svg": 61673,
	"./flat/trash-solid.svg": 67984,
	"./flat/ui-flow-compact.svg": 63555,
	"./flat/ui-flow-light.svg": 66488,
	"./flat/ui-flow-solid.svg": 81097,
	"./flat/underline.svg": 75864,
	"./flat/unknown-warning-compact.svg": 61493,
	"./flat/unknown-warning-light.svg": 98946,
	"./flat/unknown-warning-solid.svg": 10143,
	"./flat/up-2-compact.svg": 77546,
	"./flat/up-2-light.svg": 82997,
	"./flat/up-2-solid.svg": 91372,
	"./flat/up-compact.svg": 98067,
	"./flat/up-light.svg": 59848,
	"./flat/up-solid.svg": 57849,
	"./flat/upload-compact.svg": 44879,
	"./flat/upload-light.svg": 57668,
	"./flat/upload-solid.svg": 58421,
	"./flat/users-authentication-compact.svg": 22025,
	"./flat/users-authentication-light.svg": 25526,
	"./flat/users-authentication-solid.svg": 8723,
	"./flat/users-directory-compact.svg": 81410,
	"./flat/users-directory-light.svg": 63805,
	"./flat/users-directory-solid.svg": 28180,
	"./flat/users-invitation-compact.svg": 79500,
	"./flat/users-invitation-light.svg": 70567,
	"./flat/users-invitation-solid.svg": 78010,
	"./flat/users-rights-compact.svg": 47012,
	"./flat/users-rights-light.svg": 99983,
	"./flat/users-rights-solid.svg": 7170,
	"./flat/video-compact.svg": 37441,
	"./flat/video-light.svg": 15646,
	"./flat/video-muted-compact.svg": 14419,
	"./flat/video-muted-light.svg": 18792,
	"./flat/video-muted-solid.svg": 16793,
	"./flat/video-solid.svg": 34651,
	"./flat/visibility-hidden.svg": 29877,
	"./flat/visibility-invisible.svg": 45610,
	"./flat/visibility-visible.svg": 84489,
	"./flat/warning-circle-compact.svg": 40825,
	"./flat/warning-circle-light.svg": 80294,
	"./flat/warning-circle-solid.svg": 94499,
	"./flat/warning-compact.svg": 12736,
	"./flat/warning-light.svg": 97691,
	"./flat/warning-solid.svg": 22734,
	"./flat/while-loop-end-compact.svg": 65410,
	"./flat/while-loop-end-light.svg": 43549,
	"./flat/while-loop-end-solid.svg": 48500,
	"./flat/while-loop-start-compact.svg": 34793,
	"./flat/while-loop-start-light.svg": 78422,
	"./flat/while-loop-start-solid.svg": 81011,
	"./flat/wiki-compact.svg": 45536,
	"./flat/wiki-light.svg": 99899,
	"./flat/wiki-solid.svg": 3918,
	"./flat/workflows-compact.svg": 84470,
	"./flat/workflows-light.svg": 27457,
	"./flat/workflows-solid.svg": 77768,
	"./flat/workspaces-add-compact.svg": 1760,
	"./flat/workspaces-add-light.svg": 74011,
	"./flat/workspaces-add-solid.svg": 99054,
	"./flat/workspaces-compact.svg": 77350,
	"./flat/workspaces-light.svg": 38065,
	"./flat/workspaces-solid.svg": 46744,
	"./flat/x-compact.svg": 4380,
	"./flat/x-light.svg": 22487,
	"./flat/x-solid.svg": 31178,
	"./flat/zap-compact.svg": 85237,
	"./flat/zap-light.svg": 8930,
	"./flat/zap-solid.svg": 98079,
	"./flat/zoom-in-compact.svg": 68619,
	"./flat/zoom-in-light.svg": 75024,
	"./flat/zoom-in-solid.svg": 12609,
	"./flat/zoom-out-compact.svg": 91138,
	"./flat/zoom-out-light.svg": 49981,
	"./flat/zoom-out-solid.svg": 15412,
	"./flat/zoom-reset-compact.svg": 53707,
	"./flat/zoom-reset-light.svg": 69136,
	"./flat/zoom-reset-solid.svg": 34785,
	"./fullColour/android.svg": 30651,
	"./fullColour/appLogo.svg": 43114,
	"./fullColour/app_store.svg": 80289,
	"./fullColour/apple.svg": 76810,
	"./fullColour/apps.svg": 95658,
	"./fullColour/base.svg": 28709,
	"./fullColour/box.svg": 44661,
	"./fullColour/calendar.svg": 42652,
	"./fullColour/card.svg": 30768,
	"./fullColour/chrome.svg": 43296,
	"./fullColour/context-cards.svg": 91373,
	"./fullColour/custom_external.svg": 14539,
	"./fullColour/custom_internal.svg": 17557,
	"./fullColour/do-not-disturb-dash-white.svg": 63688,
	"./fullColour/dropbox.svg": 85792,
	"./fullColour/firefox.svg": 25045,
	"./fullColour/form.svg": 3116,
	"./fullColour/gantt.svg": 56444,
	"./fullColour/gcalendar.svg": 11983,
	"./fullColour/gmail.svg": 87200,
	"./fullColour/google.svg": 49291,
	"./fullColour/google_play.svg": 32948,
	"./fullColour/googledrive.svg": 47649,
	"./fullColour/grid.svg": 88254,
	"./fullColour/hellosign.svg": 1101,
	"./fullColour/import-app.svg": 62991,
	"./fullColour/ios.svg": 62417,
	"./fullColour/jira.svg": 45370,
	"./fullColour/kanban.svg": 93763,
	"./fullColour/microsoft.svg": 2006,
	"./fullColour/mscalendar.svg": 50708,
	"./fullColour/msoutlook.svg": 73239,
	"./fullColour/msteams.svg": 67056,
	"./fullColour/onedrive.svg": 82370,
	"./fullColour/onedrivegcc.svg": 76483,
	"./fullColour/publisher.svg": 44934,
	"./fullColour/rules.svg": 66535,
	"./fullColour/safari.svg": 63474,
	"./fullColour/salesforce.svg": 32911,
	"./fullColour/shareddashboards.svg": 97594,
	"./fullColour/sharedtrackcontent.svg": 56685,
	"./fullColour/sharepoint.svg": 3335,
	"./fullColour/slack.svg": 10782,
	"./fullColour/smartsheet.svg": 45070,
	"./fullColour/table.svg": 42,
	"./fullColour/templates.svg": 5463,
	"./fullColour/whiteboardfox.svg": 45914,
	"./fullColour/workflows.svg": 24363,
	"./fullColour/zendesk.svg": 47586,
	"./fullColour/zoom.svg": 77915,
	"./light/application-light-focus.svg": 7983,
	"./light/application-light.svg": 15148,
	"./light/apps-light-focus.svg": 74039,
	"./light/apps-light.svg": 95540,
	"./light/attach-light-focus.svg": 51456,
	"./light/attach-light.svg": 6159,
	"./light/back-arrow-light-focus.svg": 97898,
	"./light/back-arrow-light.svg": 13649,
	"./light/book-light-focus.svg": 48404,
	"./light/book-light.svg": 15587,
	"./light/burger-menu-light-focus.svg": 14804,
	"./light/burger-menu-light.svg": 12259,
	"./light/calendar-light-focus.svg": 63937,
	"./light/calendar-light.svg": 36470,
	"./light/camera-switch-light-focus.svg": 38447,
	"./light/camera-switch-light.svg": 78156,
	"./light/chat-light-focus.svg": 50157,
	"./light/chat-light.svg": 66258,
	"./light/delete-light-focus.svg": 92198,
	"./light/delete-light.svg": 93469,
	"./light/download-light-focus.svg": 66739,
	"./light/download-light.svg": 94560,
	"./light/edit-light-focus.svg": 44971,
	"./light/edit-light.svg": 70520,
	"./light/email-light-focus.svg": 34441,
	"./light/email-light.svg": 40254,
	"./light/emoji-light-focus.svg": 97607,
	"./light/emoji-light.svg": 70308,
	"./light/extensions-light-focus.svg": 9037,
	"./light/extensions-light.svg": 63794,
	"./light/eye-light-focus.svg": 3190,
	"./light/eye-light.svg": 52365,
	"./light/file-light-focus.svg": 76485,
	"./light/file-light.svg": 86186,
	"./light/files-light-focus.svg": 25100,
	"./light/files-light.svg": 20456,
	"./light/folder-closed-light-focus.svg": 34924,
	"./light/folder-closed-light.svg": 69851,
	"./light/folder-closed-move-up-light-focus.svg": 53256,
	"./light/folder-closed-move-up-light.svg": 52631,
	"./light/folder-open-light-focus.svg": 5268,
	"./light/folder-open-light.svg": 49987,
	"./light/help-light-focus.svg": 35990,
	"./light/help-light.svg": 62381,
	"./light/history-light-focus.svg": 77953,
	"./light/history-light.svg": 41174,
	"./light/home-light-focus.svg": 82778,
	"./light/home-light.svg": 97025,
	"./light/horizontal-ellipsis-light-focus.svg": 31577,
	"./light/horizontal-ellipsis-light.svg": 5870,
	"./light/image-light-focus.svg": 27446,
	"./light/image-light.svg": 97517,
	"./light/info-light-focus.svg": 88399,
	"./light/info-light.svg": 76620,
	"./light/link-light-focus.svg": 16515,
	"./light/link-light.svg": 14736,
	"./light/log-out-light-focus.svg": 15828,
	"./light/log-out-light.svg": 30640,
	"./light/look-and-feel-light-focus.svg": 58855,
	"./light/look-and-feel-light.svg": 78756,
	"./light/maximise-light-focus.svg": 91830,
	"./light/maximise-light.svg": 33997,
	"./light/meeting-participant-add-light-focus.svg": 46380,
	"./light/meeting-participant-add-light.svg": 23355,
	"./light/members-add-light-focus.svg": 3022,
	"./light/members-add-light.svg": 33093,
	"./light/members-light-focus.svg": 748,
	"./light/members-light.svg": 65243,
	"./light/minimise-light-focus.svg": 84796,
	"./light/minimise-light.svg": 35275,
	"./light/news-light-focus.svg": 54098,
	"./light/news-light.svg": 11673,
	"./light/notifications-light-focus.svg": 34865,
	"./light/notifications-light.svg": 52902,
	"./light/open-light-focus.svg": 10851,
	"./light/open-light.svg": 96912,
	"./light/organiser-light-focus.svg": 30427,
	"./light/organiser-light.svg": 88808,
	"./light/other-captcha-light-focus.svg": 9622,
	"./light/other-captcha-light.svg": 6170,
	"./light/other-stats-light-focus.svg": 24365,
	"./light/other-stats-light.svg": 83986,
	"./light/phone-down-light-focus.svg": 92730,
	"./light/phone-down-light.svg": 4161,
	"./light/phone-light-focus.svg": 33777,
	"./light/phone-light.svg": 95174,
	"./light/phone-up-light-focus.svg": 50685,
	"./light/phone-up-light.svg": 93634,
	"./light/pin-light-focus.svg": 91472,
	"./light/pin-light.svg": 58143,
	"./light/privacy-light-focus.svg": 8809,
	"./light/privacy-light.svg": 58270,
	"./light/private-light-focus.svg": 51720,
	"./light/private-light.svg": 50039,
	"./light/profile-light-focus.svg": 5594,
	"./light/profile-light.svg": 90465,
	"./light/reset-light.svg": 65995,
	"./light/search-light-focus.svg": 10147,
	"./light/search-light.svg": 87376,
	"./light/send-light-focus.svg": 35505,
	"./light/send-light.svg": 75942,
	"./light/settings-light-focus.svg": 83588,
	"./light/settings-light.svg": 23603,
	"./light/share-light-focus.svg": 3956,
	"./light/share-light.svg": 12336,
	"./light/share-social-light-focus.svg": 15268,
	"./light/share-social-light.svg": 69331,
	"./light/social-likes-light-focus.svg": 9,
	"./light/social-likes-light.svg": 99774,
	"./light/tasks-light-focus.svg": 48055,
	"./light/tasks-light.svg": 84436,
	"./light/templates-light-focus.svg": 64708,
	"./light/templates-light.svg": 3027,
	"./light/thumb-up-light-focus.svg": 79529,
	"./light/thumb-up-light.svg": 52862,
	"./light/trash-3-light.svg": 95896,
	"./light/unknown-warning-light-focus.svg": 19788,
	"./light/unknown-warning-light.svg": 34011,
	"./light/users-authentication-light-focus.svg": 1434,
	"./light/users-authentication-light.svg": 74049,
	"./light/users-default-light-focus.svg": 32265,
	"./light/users-default-light.svg": 55422,
	"./light/video-light-focus.svg": 43560,
	"./light/video-light.svg": 50487,
	"./light/visibility-hidden.svg": 22700,
	"./light/visibility-invisible.svg": 41721,
	"./light/visibility-visible.svg": 71094,
	"./light/workflows-light-focus.svg": 75675,
	"./light/workflows-light.svg": 46472,
	"./light/workspaces-light-focus.svg": 49217,
	"./light/workspaces-light.svg": 99542,
	"./light/x-light-focus.svg": 7049,
	"./light/x-light.svg": 478,
	"./meetings/camera-compact-focus.svg": 32995,
	"./meetings/camera-compact.svg": 96752,
	"./meetings/camera-light-focus.svg": 83228,
	"./meetings/camera-light.svg": 33803,
	"./meetings/camera-muted-compact-focus.svg": 82785,
	"./meetings/camera-muted-compact.svg": 89110,
	"./meetings/camera-muted-light-focus.svg": 43898,
	"./meetings/camera-muted-light.svg": 80577,
	"./meetings/full-screen-compact-focus.svg": 75252,
	"./meetings/full-screen-compact.svg": 48547,
	"./meetings/full-screen-exit-compact-focus.svg": 35367,
	"./meetings/full-screen-exit-compact.svg": 34660,
	"./meetings/full-screen-exit-light-focus.svg": 74464,
	"./meetings/full-screen-exit-light.svg": 92719,
	"./meetings/full-screen-light-focus.svg": 11627,
	"./meetings/full-screen-light.svg": 75576,
	"./meetings/layout-film-strip-compact-focus.svg": 28352,
	"./meetings/layout-film-strip-compact.svg": 53391,
	"./meetings/layout-film-strip-light-focus.svg": 19207,
	"./meetings/layout-film-strip-light.svg": 49348,
	"./meetings/layout-full-screen-compact-focus.svg": 75911,
	"./meetings/layout-full-screen-compact.svg": 67780,
	"./meetings/layout-full-screen-light-focus.svg": 62528,
	"./meetings/layout-full-screen-light.svg": 68668,
	"./meetings/layout-grid-compact-focus.svg": 13019,
	"./meetings/layout-grid-compact.svg": 86120,
	"./meetings/layout-grid-light-focus.svg": 72772,
	"./meetings/layout-grid-light.svg": 16595,
	"./meetings/layout-righthand-strip-compact-focus.svg": 92675,
	"./meetings/layout-righthand-strip-compact.svg": 49488,
	"./meetings/layout-righthand-strip-light-focus.svg": 81756,
	"./meetings/layout-righthand-strip-light.svg": 25323,
	"./meetings/microphone-compact-focus.svg": 70018,
	"./meetings/microphone-compact.svg": 98985,
	"./meetings/microphone-light-focus.svg": 79937,
	"./meetings/microphone-light.svg": 51254,
	"./meetings/microphone-muted-compact-focus.svg": 38124,
	"./meetings/microphone-muted-compact.svg": 91323,
	"./meetings/microphone-muted-light-focus.svg": 60640,
	"./meetings/microphone-muted-light.svg": 73600,
	"./meetings/present-compact-focus.svg": 82473,
	"./meetings/present-compact.svg": 6046,
	"./meetings/present-light-focus.svg": 73938,
	"./meetings/present-light.svg": 78041,
	"./meetings/record-compact-focus.svg": 48489,
	"./meetings/record-compact.svg": 91550,
	"./meetings/record-light-focus.svg": 93074,
	"./meetings/record-light.svg": 31897,
	"./meetings/recording-compact-focus.svg": 67037,
	"./meetings/recording-compact.svg": 52514,
	"./meetings/recording-light-focus.svg": 27206,
	"./meetings/recording-light.svg": 73885,
	"./meetings/screenshare-compact-focus.svg": 92141,
	"./meetings/screenshare-compact.svg": 45138,
	"./meetings/screenshare-light-focus.svg": 99350,
	"./meetings/screenshare-light.svg": 45101,
	"./solid/application-solid-focus.svg": 98991,
	"./solid/application-solid.svg": 81260,
	"./solid/approval-solid-focus.svg": 73935,
	"./solid/approval-solid.svg": 30603,
	"./solid/apps-solid-focus.svg": 14429,
	"./solid/apps-solid.svg": 33154,
	"./solid/attach-solid-focus.svg": 85250,
	"./solid/attach-solid.svg": 83337,
	"./solid/base-solid-focus.svg": 36090,
	"./solid/base-solid.svg": 12001,
	"./solid/book-solid-focus.svg": 97602,
	"./solid/book-solid.svg": 83273,
	"./solid/bottom-focus.svg": 79022,
	"./solid/bottom.svg": 38277,
	"./solid/burger-menu-solid-focus.svg": 26376,
	"./solid/burger-menu-solid.svg": 15927,
	"./solid/calendar-solid-focus.svg": 17855,
	"./solid/calendar-solid.svg": 16092,
	"./solid/camera-switch-solid-focus.svg": 53767,
	"./solid/camera-switch-solid.svg": 9412,
	"./solid/card-solid-focus.svg": 40671,
	"./solid/card-solid.svg": 36156,
	"./solid/chat-solid-focus.svg": 38103,
	"./solid/chat-solid.svg": 54900,
	"./solid/close-solid-focus.svg": 83625,
	"./solid/close-solid.svg": 24414,
	"./solid/comment-solid-focus.svg": 50890,
	"./solid/comment-solid.svg": 64721,
	"./solid/copy-solid-focus.svg": 63090,
	"./solid/copy-solid.svg": 97113,
	"./solid/delete-solid-focus.svg": 52828,
	"./solid/delete-solid.svg": 3915,
	"./solid/down-focus.svg": 5499,
	"./solid/down.svg": 15688,
	"./solid/download-solid-focus.svg": 78077,
	"./solid/download-solid.svg": 57506,
	"./solid/edit-solid-focus.svg": 99345,
	"./solid/edit-solid.svg": 9926,
	"./solid/email-solid-focus.svg": 18669,
	"./solid/email-solid.svg": 24978,
	"./solid/emoji-solid-focus.svg": 56215,
	"./solid/emoji-solid.svg": 25108,
	"./solid/extensions-solid-focus.svg": 38275,
	"./solid/extensions-solid.svg": 78544,
	"./solid/eye-solid-focus.svg": 54570,
	"./solid/eye-solid.svg": 4881,
	"./solid/file-solid-focus.svg": 21783,
	"./solid/file-solid.svg": 39732,
	"./solid/files-solid-focus.svg": 99664,
	"./solid/files-solid.svg": 5663,
	"./solid/first-focus.svg": 46713,
	"./solid/first.svg": 5486,
	"./solid/folder-closed-move-up-solid-focus.svg": 17528,
	"./solid/folder-closed-move-up-solid.svg": 35431,
	"./solid/folder-closed-solid-focus.svg": 23624,
	"./solid/folder-closed-solid.svg": 51063,
	"./solid/folder-open-solid-focus.svg": 59448,
	"./solid/folder-open-solid.svg": 68871,
	"./solid/form-solid-focus.svg": 81671,
	"./solid/form-solid.svg": 17604,
	"./solid/gantt-solid-focus.svg": 53079,
	"./solid/gantt-solid.svg": 66804,
	"./solid/grid-solid-focus.svg": 52869,
	"./solid/grid-solid.svg": 11786,
	"./solid/group-solid-focus.svg": 35604,
	"./solid/group-solid.svg": 81891,
	"./solid/history-solid-focus.svg": 95237,
	"./solid/history-solid.svg": 80106,
	"./solid/home-solid-focus.svg": 52032,
	"./solid/home-solid.svg": 34364,
	"./solid/info-solid-focus.svg": 20297,
	"./solid/info-solid.svg": 31870,
	"./solid/kanban-solid-focus.svg": 12288,
	"./solid/kanban-solid.svg": 64015,
	"./solid/last-focus.svg": 13583,
	"./solid/last.svg": 2412,
	"./solid/left-focus.svg": 65304,
	"./solid/left.svg": 83463,
	"./solid/link-solid-focus.svg": 74021,
	"./solid/link-solid.svg": 29610,
	"./solid/list-solid-focus.svg": 91581,
	"./solid/list-solid.svg": 87778,
	"./solid/lock-solid-focus.svg": 78440,
	"./solid/lock-solid.svg": 16887,
	"./solid/log-out-solid-focus.svg": 62456,
	"./solid/log-out-solid.svg": 71687,
	"./solid/look-and-feel-solid-focus.svg": 24587,
	"./solid/look-and-feel-solid.svg": 27096,
	"./solid/maximise-solid-focus.svg": 33704,
	"./solid/maximise-solid.svg": 77783,
	"./solid/meeting-participant-add-solid-focus.svg": 9072,
	"./solid/meeting-participant-add-solid.svg": 72095,
	"./solid/members-add-solid-focus.svg": 46430,
	"./solid/members-add-solid.svg": 58773,
	"./solid/members-solid-focus.svg": 42284,
	"./solid/members-solid.svg": 84219,
	"./solid/microphone-solid-focus.svg": 49813,
	"./solid/microphone-solid.svg": 77786,
	"./solid/minimise-solid-focus.svg": 92618,
	"./solid/minimise-solid.svg": 50865,
	"./solid/news-solid-focus.svg": 32320,
	"./solid/news-solid.svg": 33167,
	"./solid/note-solid-focus.svg": 13809,
	"./solid/note-solid.svg": 96230,
	"./solid/notifications-solid-focus.svg": 21369,
	"./solid/notifications-solid.svg": 65582,
	"./solid/open-solid-focus.svg": 52085,
	"./solid/open-solid.svg": 85338,
	"./solid/organiser-solid-focus.svg": 21011,
	"./solid/organiser-solid.svg": 20736,
	"./solid/other-captcha-solid-focus.svg": 21690,
	"./solid/other-captcha-solid.svg": 75969,
	"./solid/phone-down-solid-focus.svg": 19312,
	"./solid/phone-down-solid.svg": 1279,
	"./solid/phone-solid-focus.svg": 89025,
	"./solid/phone-solid.svg": 76790,
	"./solid/phone-up-solid-focus.svg": 59559,
	"./solid/phone-up-solid.svg": 45092,
	"./solid/pin-solid-focus.svg": 15312,
	"./solid/pin-solid.svg": 96671,
	"./solid/play-solid-focus.svg": 34963,
	"./solid/play-solid.svg": 77056,
	"./solid/plus-solid-focus.svg": 45061,
	"./solid/plus-solid.svg": 12989,
	"./solid/privacy-solid-focus.svg": 89061,
	"./solid/privacy-solid.svg": 8330,
	"./solid/profile-solid-focus.svg": 58490,
	"./solid/profile-solid.svg": 86497,
	"./solid/reaction-add-solid-focus.svg": 28798,
	"./solid/reaction-add-solid.svg": 82709,
	"./solid/reset-solid.svg": 14607,
	"./solid/right-focus.svg": 50237,
	"./solid/right.svg": 7266,
	"./solid/search-solid-focus.svg": 33257,
	"./solid/search-solid.svg": 32254,
	"./solid/send-solid-focus.svg": 4047,
	"./solid/send-solid.svg": 81004,
	"./solid/settings-solid-focus.svg": 87762,
	"./solid/settings-solid.svg": 47929,
	"./solid/share-solid-focus.svg": 51900,
	"./solid/share-solid.svg": 93995,
	"./solid/sliders-solid-focus.svg": 73675,
	"./solid/sliders-solid.svg": 14136,
	"./solid/social-likes-solid-focus.svg": 88055,
	"./solid/social-likes-solid.svg": 88692,
	"./solid/start-thread-solid-focus.svg": 36076,
	"./solid/start-thread-solid.svg": 31611,
	"./solid/stats-solid-focus.svg": 572,
	"./solid/stats-solid.svg": 35371,
	"./solid/table-solid-focus.svg": 57369,
	"./solid/table-solid.svg": 83502,
	"./solid/tasks-solid-focus.svg": 29595,
	"./solid/tasks-solid.svg": 13576,
	"./solid/templates-solid-focus.svg": 7412,
	"./solid/templates-solid.svg": 10819,
	"./solid/text-file-solid-focus.svg": 41085,
	"./solid/text-file-solid.svg": 69218,
	"./solid/tile-view-solid-focus.svg": 34391,
	"./solid/tile-view-solid.svg": 30740,
	"./solid/top-focus.svg": 50134,
	"./solid/top.svg": 51725,
	"./solid/trash-3-solid.svg": 2800,
	"./solid/trash-solid-focus.svg": 2787,
	"./solid/trash-solid.svg": 29232,
	"./solid/unknown-warning-solid-focus.svg": 18672,
	"./solid/unknown-warning-solid.svg": 52063,
	"./solid/up-focus.svg": 83212,
	"./solid/up.svg": 67707,
	"./solid/users-authentication-solid-focus.svg": 57508,
	"./solid/users-authentication-solid.svg": 71219,
	"./solid/video-solid-focus.svg": 43404,
	"./solid/video-solid.svg": 41115,
	"./solid/visibility-hidden.svg": 26549,
	"./solid/visibility-invisible.svg": 39402,
	"./solid/visibility-visible.svg": 3241,
	"./solid/warning-solid.svg": 92558,
	"./solid/workflows-solid-focus.svg": 66203,
	"./solid/workflows-solid.svg": 27304,
	"./solid/workspaces-solid-focus.svg": 88779,
	"./solid/workspaces-solid.svg": 44760,
	"./solid/x-solid-focus.svg": 72197,
	"./solid/x-solid.svg": 89898,
	"./special/add-focus.svg": 41266,
	"./special/add.svg": 34361,
	"./special/chevron-down-focus.svg": 57454,
	"./special/chevron-down.svg": 63446,
	"./special/chevron-left-focus.svg": 38054,
	"./special/chevron-left.svg": 28509,
	"./special/chevron-right-focus.svg": 7827,
	"./special/chevron-right.svg": 32672,
	"./special/chevron-up-focus.svg": 93494,
	"./special/chevron-up.svg": 60877,
	"./special/dash-focus.svg": 36807,
	"./special/dash.svg": 92324,
	"./special/dismiss-focus.svg": 61727,
	"./special/dismiss.svg": 31740,
	"./special/do-not-disturb-focus.svg": 76990,
	"./special/do-not-disturb.svg": 56373,
	"./special/down-focus.svg": 38263,
	"./special/down.svg": 11604,
	"./special/draggable-handle-focus.svg": 85079,
	"./special/draggable-handle.svg": 5095,
	"./special/ellipsis-focus.svg": 51938,
	"./special/ellipsis.svg": 66665,
	"./special/favourite-checked-focus.svg": 13114,
	"./special/favourite-checked.svg": 97601,
	"./special/favourite-focus.svg": 98914,
	"./special/favourite.svg": 14633,
	"./special/left-focus.svg": 33380,
	"./special/left.svg": 64627,
	"./special/nudge-down-focus.svg": 11585,
	"./special/nudge-down.svg": 74838,
	"./special/nudge-right-focus.svg": 60403,
	"./special/nudge-right.svg": 90336,
	"./special/pin-solid-focus.svg": 47820,
	"./special/pin-solid.svg": 27451,
	"./special/pop-out-to-modal-focus.svg": 44239,
	"./special/pop-out-to-modal.svg": 69740,
	"./special/right-focus.svg": 71361,
	"./special/right.svg": 33334,
	"./special/tick-focus.svg": 91184,
	"./special/tick.svg": 14655,
	"./special/up-focus.svg": 89632,
	"./special/up.svg": 29167,
	"./text-formatting/block-quote-focus.svg": 89649,
	"./text-formatting/block-quote.svg": 31270,
	"./text-formatting/bold-focus.svg": 24696,
	"./text-formatting/bold.svg": 22887,
	"./text-formatting/code-block-focus.svg": 64754,
	"./text-formatting/code-block.svg": 58937,
	"./text-formatting/code-focus.svg": 19038,
	"./text-formatting/code.svg": 20085,
	"./text-formatting/fill-colour-focus.svg": 9289,
	"./text-formatting/fill-colour.svg": 29502,
	"./text-formatting/image-focus.svg": 13270,
	"./text-formatting/image.svg": 24813,
	"./text-formatting/italic-focus.svg": 43493,
	"./text-formatting/italic.svg": 49322,
	"./text-formatting/link-focus.svg": 55561,
	"./text-formatting/link.svg": 84222,
	"./text-formatting/ordered-list-focus.svg": 19949,
	"./text-formatting/ordered-list.svg": 45650,
	"./text-formatting/strikethrough-focus.svg": 67908,
	"./text-formatting/strikethrough.svg": 97203,
	"./text-formatting/text-colour-focus.svg": 60027,
	"./text-formatting/text-colour.svg": 70216,
	"./text-formatting/text-formatting-focus.svg": 70494,
	"./text-formatting/text-formatting.svg": 21653,
	"./text-formatting/underline-focus.svg": 39221,
	"./text-formatting/underline.svg": 21658,
	"./text-formatting/unordered-list-focus.svg": 85644,
	"./text-formatting/unordered-list.svg": 21691,
	"./xwiki/compact/application-index-small-xwiki-compact-focus.svg": 94932,
	"./xwiki/compact/application-index-small-xwiki-compact.svg": 29763,
	"./xwiki/compact/class-small-xwiki-compact-focus.svg": 4313,
	"./xwiki/compact/class-small-xwiki-compact.svg": 85966,
	"./xwiki/compact/export-small-xwiki-compact-focus.svg": 92925,
	"./xwiki/compact/export-small-xwiki-compact.svg": 22709,
	"./xwiki/compact/heart-small-xwiki-compact-focus.svg": 16517,
	"./xwiki/compact/heart-small-xwiki-compact.svg": 56714,
	"./xwiki/compact/index-small-xwiki-compact-focus.svg": 98717,
	"./xwiki/compact/index-small-xwiki-compact.svg": 65186,
	"./xwiki/compact/log-out-person-small-xwiki-compact-focus.svg": 87614,
	"./xwiki/compact/log-out-person-small-xwiki-compact.svg": 48277,
	"./xwiki/compact/objects-small-xwiki-compact-focus.svg": 3845,
	"./xwiki/compact/objects-small-xwiki-compact.svg": 98122,
	"./xwiki/compact/print-small-xwiki-compact-focus.svg": 37800,
	"./xwiki/compact/print-small-xwiki-compact.svg": 80215,
	"./xwiki/compact/upload-small-xwiki-compact-focus.svg": 684,
	"./xwiki/compact/upload-small-xwiki-compact.svg": 50907,
	"./xwiki/compact/wiki-small-xwiki-compact-focus.svg": 19991,
	"./xwiki/compact/wiki-small-xwiki-compact.svg": 48372,
	"./xwiki/light/applications-xwiki-light-focus.svg": 77026,
	"./xwiki/light/applications-xwiki-light.svg": 94473,
	"./xwiki/light/compass-xwiki-light-focus.svg": 35939,
	"./xwiki/light/compass-xwiki-light.svg": 96112,
	"./xwiki/light/content-annotation-xwiki-light-focus.svg": 61104,
	"./xwiki/light/content-annotation-xwiki-light.svg": 58463,
	"./xwiki/light/content-delete-xwiki-light-focus.svg": 31310,
	"./xwiki/light/content-delete-xwiki-light.svg": 70373,
	"./xwiki/light/content-export-xwiki-light-focus.svg": 18289,
	"./xwiki/light/content-export-xwiki-light.svg": 86374,
	"./xwiki/light/content-file-server-xwiki-light-focus.svg": 78225,
	"./xwiki/light/content-file-server-xwiki-light.svg": 59942,
	"./xwiki/light/content-import-xwiki-light-focus.svg": 80984,
	"./xwiki/light/content-import-xwiki-light.svg": 48167,
	"./xwiki/light/content-localisation-xwiki-light-focus.svg": 77103,
	"./xwiki/light/content-localisation-xwiki-light.svg": 44716,
	"./xwiki/light/content-templates-xwiki-light-focus.svg": 62254,
	"./xwiki/light/content-templates-xwiki-light.svg": 3333,
	"./xwiki/light/edit-mode-xwiki-light-focus.svg": 84007,
	"./xwiki/light/edit-mode-xwiki-light.svg": 36356,
	"./xwiki/light/edit-naming-xwiki-light-focus.svg": 25574,
	"./xwiki/light/edit-naming-xwiki-light.svg": 83549,
	"./xwiki/light/edit-syntax-highlighting-xwiki-light-focus.svg": 80326,
	"./xwiki/light/edit-syntax-highlighting-xwiki-light.svg": 83421,
	"./xwiki/light/edit-syntaxes-xwiki-light-focus.svg": 60775,
	"./xwiki/light/edit-syntaxes-xwiki-light.svg": 96516,
	"./xwiki/light/edit-wysiwyg-xwiki-light-focus.svg": 55199,
	"./xwiki/light/edit-wysiwyg-xwiki-light.svg": 38268,
	"./xwiki/light/email-advanced-settings-xwiki-light-focus.svg": 27644,
	"./xwiki/light/email-advanced-settings-xwiki-light.svg": 91915,
	"./xwiki/light/email-sending-status-xwiki-light-focus.svg": 79315,
	"./xwiki/light/email-sending-status-xwiki-light.svg": 41024,
	"./xwiki/light/email-sending-xwiki-light-focus.svg": 83586,
	"./xwiki/light/email-sending-xwiki-light.svg": 32041,
	"./xwiki/light/extensions-history-xwiki-light-focus.svg": 1626,
	"./xwiki/light/extensions-history-xwiki-light.svg": 2465,
	"./xwiki/light/extensions-update-xwiki-light-focus.svg": 94007,
	"./xwiki/light/extensions-update-xwiki-light.svg": 74292,
	"./xwiki/light/menus-xwiki-light-focus.svg": 37407,
	"./xwiki/light/menus-xwiki-light.svg": 65724,
	"./xwiki/light/other-logging-xwiki-light-focus.svg": 66201,
	"./xwiki/light/other-logging-xwiki-light.svg": 45326,
	"./xwiki/light/panels-xwiki-light-focus.svg": 96066,
	"./xwiki/light/panels-xwiki-light.svg": 41,
	"./xwiki/light/presentation-xwiki-light-focus.svg": 43667,
	"./xwiki/light/presentation-xwiki-light.svg": 75648,
	"./xwiki/light/search-suggest-xwiki-light-focus.svg": 56730,
	"./xwiki/light/search-suggest-xwiki-light.svg": 42145,
	"./xwiki/light/social-mentions-xwiki-light-focus.svg": 16616,
	"./xwiki/light/social-mentions-xwiki-light.svg": 46007,
	"./xwiki/light/social-message-stream-xwiki-light-focus.svg": 45247,
	"./xwiki/light/social-message-stream-xwiki-light.svg": 14620,
	"./xwiki/light/social-notifications-xwiki-light-focus.svg": 56641,
	"./xwiki/light/social-notifications-xwiki-light.svg": 77686,
	"./xwiki/light/thread-xwiki-light-focus.svg": 28579,
	"./xwiki/light/thread-xwiki-light.svg": 89040,
	"./xwiki/light/users-directory-xwiki-light-focus.svg": 5841,
	"./xwiki/light/users-directory-xwiki-light.svg": 89030,
	"./xwiki/light/users-groups-xwiki-light-focus.svg": 25922,
	"./xwiki/light/users-groups-xwiki-light.svg": 67817,
	"./xwiki/light/users-invitation-xwiki-light-focus.svg": 43291,
	"./xwiki/light/users-invitation-xwiki-light.svg": 2312,
	"./xwiki/light/users-profile-xwiki-light-focus.svg": 98267,
	"./xwiki/light/users-profile-xwiki-light.svg": 21608,
	"./xwiki/light/users-registration-xwiki-light-focus.svg": 16085,
	"./xwiki/light/users-registration-xwiki-light.svg": 79578,
	"./xwiki/light/users-rights-xwiki-light-focus.svg": 95747,
	"./xwiki/light/users-rights-xwiki-light.svg": 90288,
	"./xwiki/light/wiki-descriptor-xwiki-light-focus.svg": 78373,
	"./xwiki/light/wiki-descriptor-xwiki-light.svg": 65898,
	"./xwiki/light/wiki-rights-xwiki-light-focus.svg": 44591,
	"./xwiki/light/wiki-rights-xwiki-light.svg": 57900,
	"./xwiki/light/wiki-templates-xwiki-light-focus.svg": 69593,
	"./xwiki/light/wiki-templates-xwiki-light.svg": 54446,
	"./xwiki/light/wiki-xwiki-light-focus.svg": 91311,
	"./xwiki/light/wiki-xwiki-light.svg": 20620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60916;